<template>
    <div class="d-flex align-items-center order-scnd w-100">
        <div class="mainLogo hide-for-mobile" v-if="!['Hanko'].includes(product)">
            <router-link to="/" v-if="!$parent.$parent.theme">
                <img :src='DARK_LOGO_URL' alt="Logo" :style="product == 'Copyrack' ? 'max-width : 120px !important; width : 120px !important;' : product == 'market101' ? 'width: 100px;': product == 'Capital-Street'? 'width: 70px;' : ''" />
            </router-link>
            <router-link to="/" v-if="$parent.$parent.theme">
                <img :src='LIGHT_LOGO_URL' alt="Logo" :style="product == 'Copyrack' ? 'max-width : 120px !important; width : 120px !important;' : product == 'market101' ? 'width: 100px;': product == 'Capital-Street'? 'width: 70px;' : ''" />
            </router-link>
        </div>
        <div class="header-profit-row w-100 d-flex align-items-center">
            <div class="dropdown hide-for-mobile" :class="{ 'ml-3': !['Hanko'].includes(product) }">

                <!-- <div class="dropdown"> -->
                <!-- <button type="button" class="btn appButton" v-show="get_user!=undefined" @click="window.location.origin"> -->

                <a href="javascript:void(0)" class="btn appButton changeUser" @click="show_dropdown ^= true">
                    <!-- class="dropdown-toggle" data-toggle="dropdown" -->
                    <p class="account-type" style="">{{ (get_user.username || '').toUpperCase().includes('DEMO') ? 'DEMO' : "LIVE"}} </p>
                    {{ (get_user.username || '').split("$$")[1] || "-" }}
                    <!--#1b9981 {{accBalance.CUSTOMER_ID || '-'}}{{accBalance.ACCOUNT_ID || '-'}} -->
                </a>
                <div class="dropdown-menu myWatchlist show" style="width: 150px !important;" v-if="show_dropdown && product == 'act'">
                    <!-- -->
                    <a class="dropdown-item justify-content-between d-flex" href="javascript:void(0)" v-for="item in userList" @click.prevent="changeUser(item, false)">
                        {{item.user}}
                        <span title="Un-link Account" class="" @click.stop="removeUserDB(item)"><feather size="13px" type="minus-circle"></feather></span>
                    </a>
                    <a class="dropdown-item justify-content-between" href="#" @click.prevent="changeUser({}, true)">
                        <feather class="mr-2" size="13px" type="plus-circle"></feather> Add Account
                    </a>
                </div>
                <!-- </div>
                    <button type="button" class="btn appButton justify-content-center">
                        Real: {{accBalance.ACCOUNT_ID || '-'}}
                    </button> -->
                        <!-- <div class="dropdown-menu">
                    <a class="dropdown-item" href="#">Real: 100001</a>
                    <a class="dropdown-item" href="#">Real: 100002</a>
                    <a class="dropdown-item" href="#">Real: 100003</a>
                </div> -->
            </div>
            <div class="mainHeader-hanko d-flex" v-if="['Hanko'].includes(product)">
                <div class="mainHeader-hanko-left d-flex">
                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p> {{$t('balance')}} <span> {{ formatCurrency(accBalance.AMOUNT, accBalance.ACCOUNT_CURRENCY) }}</span> </p>
                        </a>
                    </div>
                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p>
                                {{$t('equity')}} <span>{{ formatCurrency((parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0)).toFixed(getPrecisionValue()), accBalance.ACCOUNT_CURRENCY) }}</span>
                            </p>
                        </a>
                    </div>
                    <div class="boxBal ml-2" v-if="product != 'Hanko'">
                        <a href="javascript:void(0)">
                            <p>{{$t('margin_level')}} <span>{{ calculateMarginLevel(accBalance) || '0' }}%</span></p>
                        </a>
                    </div>
                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p> {{$t('used_margin')}}
                                <!-- <span >{{ formatCurrency(parseFloat(parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0) - parseFloat(accBalance.ACCOUNT_USABLE_MARGIN || 0).toFixed(getPrecisionValue())), accBalance.ACCOUNT_CURRENCY) }}</span> -->
                                <span>{{ formatCurrency(accBalance.ACCOUNT_USED_MARGIN, accBalance.ACCOUNT_CURRENCY) }}</span>
                            </p>
                        </a>
                    </div>
                </div>
                <div class="mainHeader-hanko-center ">
                    <router-link to="/" v-if="!$parent.$parent.theme">
                        <img :src='DARK_LOGO_URL' alt="new-logo-black" width="120px" />
                    </router-link>
                    <router-link to="/" v-if="$parent.$parent.theme">
                        <img :src='LIGHT_LOGO_URL' alt="new-logo-white" width="120px" />
                    </router-link>

                </div>
                <div class="mainHeader-hanko-right d-flex">
                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p>{{$t('free_margin')}}
                                <span>
                                    <!-- {{ accBalance.ACCOUNT_USABLE_MARGIN || 0 }}-- -->
                                    <!-- {{ formatCurrency(parseFloat(parseFloat(accBalance.ACCOUNT_USABLE_MARGIN || 0) + parseFloat(gelGrossPL || 0)).toFixed(2), accBalance.ACCOUNT_CURRENCY) }} -->
                                    {{ formatCurrency(
                                        parseFloat(parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0) - parseFloat(accBalance.ACCOUNT_USED_MARGIN || 0)
                                    ).toFixed(2), accBalance.ACCOUNT_CURRENCY) }}
                                </span>
                            </p>
                        </a>
                    </div>
                    <!-- <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p>Gross P/L<span>{{ gelGrossPL || 0 }}</span></p>
                        </a>
                    </div> -->
                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p>
                                {{$t('unrealised_pl')}} <span>{{ formatCurrency(gelbalancePL,accBalance.ACCOUNT_CURRENCY)}}</span>
                            </p>
                        </a>
                    </div>

                    <div class="boxBal ml-2">
                        <a href="javascript:void(0)">
                            <p>
                                {{$t('bonus')}} <span>{{ formatCurrency((Number(accBalance.ACCOUNT_BONUS) || 0),accBalance.ACCOUNT_CURRENCY) }}</span>
                            </p>
                        </a>
                    </div>
                </div>
            </div>

            <div class="d-flex" v-else>
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('balance')}} <span>{{ formatCurrency((accBalance.AMOUNT || 0), accBalance.ACCOUNT_CURRENCY)}}</span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('equity')}} <span>{{formatCurrency( (parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0)), accBalance.ACCOUNT_CURRENCY )}}</span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2" v-if="product != 'Hanko'">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('margin_level')}} <span>{{ calculateMarginLevel(accBalance) || 0}}%</span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p> {{$t('used_margin')}}
                            <span>{{ formatCurrency(accBalance.ACCOUNT_USED_MARGIN, accBalance.ACCOUNT_CURRENCY) }}</span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2 d-none">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('free_margin')}}
                            <span>
                                {{ (formatCurrency(accBalance.ACCOUNT_USABLE_MARGIN || 0), accBalance.ACCOUNT_CURRENCY)}}
                                <!-- {{ formatCurrency(parseFloat(parseFloat(accBalance.ACCOUNT_USABLE_MARGIN || 0) +  arseFloat(gelGrossPL || 0)).toFixed(getPrecisionValue()), accBalance.ACCOUNT_CURRENCY) }} -->
                            </span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>{{$t('free_margin')}}
                            <span>
                                {{ formatCurrency(parseFloat(parseFloat(accBalance.AMOUNT || 0) + parseFloat(gelGrossPL || 0) - parseFloat(accBalance.ACCOUNT_USED_MARGIN || 0)).toFixed(2),
                                accBalance.ACCOUNT_CURRENCY) }}
                            </span>
                            <!-- <span>
                                {{ currencyIcon[accBalance.ACCOUNT_CURRENCY] }}
                                {{ parseFloat(parseFloat(accBalance.ACCOUNT_USABLE_MARGIN || 0) +  parseFloat(gelGrossPL || 0)).toFixed(getPrecisionValue()) }}
                            </span> -->
                        </p>
                    </a>
                </div>
                <!-- <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>Gross P/L<span>{{ gelGrossPL || 0 }}</span></p>
                    </a>
                </div> -->
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('unrealised_pl')}}<span>{{ formatCurrency(gelbalancePL || 0, accBalance.ACCOUNT_CURRENCY)}}</span>
                        </p>
                    </a>
                </div>
                <div class="boxBal ml-2">
                    <a href="javascript:void(0)">
                        <p>
                            {{$t('bonus')}} <span>{{ formatCurrency((Number(accBalance.ACCOUNT_BONUS) || 0), accBalance.ACCOUNT_CURRENCY) }}</span>
                        </p>
                    </a>
                </div>
            </div>
        </div>
        <!-- <div class="switch-toggle headerSwitchToggle mx-3" v-if="product == 'market101'">
            <ul class="d-flex align-items-center justify-content-between">
            <li><router-link to="/" class=" white" :class="{'active' : !['leaders','leader-detail'].includes($route.name)}">Manual Trading</router-link></li>
            <li><router-link to="/leaders" class=" white" :class="{'active' : ['leaders','leader-detail'].includes($route.name)}">Copy Trading</router-link></li>
            </ul>
        </div> -->
        <app-register v-if="page_type == 'register'"></app-register>
        <appLogin :login_user="login_user" @close="()=>login_user = {}" v-else-if="Object.keys(login_user).length"></appLogin>
    </div>
</template>
<script>
import { commonAllmixins } from "@/plugins/commonAll";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
const product_type = process.env.product_type;
const product = process.env.product;
let balanceDebounce;
import UserDB from '@/store/userDB';
import app_login from "../user/login";
import app_register from "./register";
export default {
    name: "app-header-balance",
    mixins: [commonAllmixins, UserDB],
    data() {
        return {
            currencyIcon: { EUR: "€", USD: "$", GBP: "£", CHF: "CHF", JPY: "¥", AUD: "$", "CAD": "C$", BTC: "₿" },
            theme: "dark-theme",
            DARK_LOGO_URL: process.env.LOGO_URL_DARK,
            LIGHT_LOGO_URL: process.env.LOGO_URL_LIGHT,
            // DARK_LOGO_UPDATED_URL: '../../../../static/website/images/hanko-new-logo-black.png',
            // LIGHT_LOGO_UPDATED_URL: '../../../../static/website/images/hanko-new-logo-white.png',
            product,
            show_dropdown : false,
            userList : [],
            login_user : {},
            page_type : ''
        };
    },
    components : { appRegister: app_register, appLogin: app_login },
    watch: {
        openTradeList(val) {
            this.getBalance();
        },
    },
    computed: {
        instruments() {
            try {
                this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
                return this.$store.getters[Const.GET_PROVIDERS][
                    "priceFeed"
                ].iCache.asKeysValueArrayAll();
            } catch (ex) {
                return {};
            }
        },
        gelbalancePL() {
            const _that = this
            let data = this.openTradeList;
            let pl = 0;
            try {
                data.forEach((list) => {
                    // pl += parseFloat(this.getPl(list,this.instruments[list.Symbol]))
                    pl += parseFloat(
                        this.getProfitLoss( _that.accountList.Currency, list, _that.instruments[list.Symbol], _that.instruments, 0 )
                    );
                });
                return parseFloat(pl);
            } catch (e) {
                return 0;
            }
        },

        gelGrossPL() {
            let data = this.openTradeList;
            let pl = 0;
            try {
                data.forEach((list) => {
                    // pl += parseFloat(this.getPl(list,this.instruments[list.Symbol]))
                    pl += parseFloat(
                        this.getProfitLoss( this.accountList.Currency, list, this.instruments[list.Symbol], this.instruments, 1 )
                    );
                });
                return parseFloat(pl);
            } catch (e) {
                return 0;
            }
        },
    },
    methods: {
        removeUserDB(item){
            this.removeUser(item.user).then(data =>{
                console.log("removeUser:", data);
                this.userList = data;
            });
        },
        changeUser(user = {}, addAccount){
            if(user.user && (this.get_user.username || '').split("$$")[1] == user.user){
                return;
            }
            this.login_user = user;
            this.login_user.addAccount = addAccount;
            this.show_dropdown = false;
        },
        getPrecisionValue() {
            if (this.accBalance && this.accBalance.ACCOUNT_CURRENCY == 'BTC') return 8
            else return 2
        },
        calculateMarginLevel(account_balance) {
            // Equity/Used margin
            // const Equity = parseFloat(account_balance.AMOUNT || 0) + parseFloat(this.gelbalancePL || 0)
            const Equity = parseFloat(account_balance.AMOUNT || 0) + parseFloat(this.gelGrossPL || 0)
            const Usedmargin = parseFloat(account_balance['ACCOUNT_USED_MARGIN'])
            return Usedmargin == 0 ? 0 : parseFloat((Equity / Usedmargin) * 100 || 0).toFixed(this.getPrecisionValue())
        },
        // getProfitLoss(accountCurrency, order, symbol, isins){
        //     try{
        //         let quantity = parseFloat(order.Quantity);
        //         let commission = parseFloat(order.Commission ? order.Commission : 0);
        //         let interest = parseFloat(order.Interest ? order.Interest : 0);
        //         let price = parseFloat(order.Price);
        //         let askPrice = parseFloat(symbol.A);
        //         let bidPrice = parseFloat(symbol.B);
        //         let BSprice = 0;
        //         if (order.Side == 1) {
        //             BSprice = askPrice - price;
        //         } else {
        //             BSprice = price - bidPrice;
        //         }
        //         return parseFloat(((BSprice * quantity * parseFloat(this.convertCurrency(accountCurrency, order.Symbol, isins))) + (commission + interest)).toFixed(2));
        //     }catch(e){ return 0}
        // },
        // convertCurrency (accountCurrency, symbol, isins){
        //     let secondCurrency = symbol.substring(3, 6);
        //     if (this.segm == "crypto") {
        //         secondCurrency = symbol.substring(4, 7);
        //         let basecurreny =
        //             accountCurrency == "BTC"
        //                 ? "BTC-"
        //                 : accountCurrency;
        //         if (secondCurrency == basecurreny) {
        //             return 1;
        //         } else {
        //             return 1 / isins[basecurreny + secondCurrency].A;
        //         }
        //     }
        //     if (secondCurrency == accountCurrency) {
        //         return 1;
        //     } else if (
        //         isins[secondCurrency + accountCurrency]
        //     ) {
        //         return isins[
        //             secondCurrency + accountCurrency
        //         ].A;
        //     } else if (
        //         isins[accountCurrency + secondCurrency]
        //     ) {
        //         return (
        //             1 /
        //             isins[
        //                 accountCurrency + secondCurrency
        //             ].A
        //         );
        //     } else {
        //         let secontoUSD = 0;
        //         let accBasetoUSD = 0;
        //         if (secondCurrency == "USD") {
        //             secontoUSD = 1;
        //         } else if (isins[secondCurrency + "USD"]) {
        //             secontoUSD = isins[secondCurrency + "USD"].A;
        //         } else if (isins["USD" + secondCurrency]) {
        //             secontoUSD = 1 / isins["USD" + secondCurrency].A;
        //         }

        //         if (accountCurrency == "USD") {
        //             accBasetoUSD = 1;
        //         } else if (accountCurrency == "BTC") {
        //             accBasetoUSD =
        //                 1 /
        //                 isins[accountCurrency + "-USD"].A;
        //         } else if (
        //             isins[accountCurrency + "USD"]
        //         ) {
        //             accBasetoUSD =
        //                 1 /
        //                 isins[accountCurrency + "USD"].A;
        //         } else if (
        //             isins["USD" + accountCurrency]
        //         ) {
        //             accBasetoUSD =
        //                 isins["USD" + accountCurrency].A;
        //         }
        //         return accBasetoUSD * secontoUSD;
        //     }
        // },

        getQuantity(list) {
            let lotBy = 100000;
            try {
                lotBy =
                    this.currencyPairs.filter((val) =>
                        val.isinid.includes(list.Symbol.slice(0, 6))
                    )[0].market_ContractSize || 100000;
            } catch (e) { }

            if (this.userSettings.position_size && this.userSettings.position_size == "1") {
                return list.Quantity;
            } else {
                return list.Quantity ? list.Quantity / lotBy : 0;
            }
        },
        getProfitLoss(accountCurrency, order, symbol, isins, grossPnL) {
            try {

                if (symbol == undefined) return "0"
                else {
                    let quantity = order.Quantity;
                    let commission = parseFloat(order.Commission ? order.Commission : 0);
                    let interest = parseFloat(order.Interest ? order.Interest : 0);
                    let price = parseFloat(order.Price);
                    let askPrice = parseFloat(symbol.A);
                    let bidPrice = parseFloat(symbol.B);
                    let BSprice = 0;
                    if (order.Side == 1) {
                        BSprice = bidPrice - price;
                    } else {
                        BSprice = price - askPrice;
                    }

                    if (grossPnL == 1) {
                        return parseFloat(
                            (
                                BSprice *
                                quantity *
                                parseFloat(
                                    this[product == 'Hanko' ? 'convertCurrencyHKT' : 'convertCurrencyNew'](
                                        accountCurrency,
                                        symbol,
                                        this.instruments,
                                        order.Side
                                    )
                                )
                            )
                        );
                    } else {

                        return parseFloat(
                            (
                                BSprice *
                                quantity *
                                parseFloat(
                                    this[product == 'Hanko' ? 'convertCurrencyHKT' : 'convertCurrencyNew'](
                                        accountCurrency,
                                        symbol,
                                        this.instruments,
                                        order.Side
                                    )
                                ) +
                                (commission + interest)
                            )
                        );
                    }
                }


                // return parseFloat((BSprice * quantity) + (commission + interest)).toFixed(2);
            } catch (e) {
                // console.log(e);
                return 0;
            }
        },
        convertCurrencyNew(accountCurrency, symbol, isins, side, orderSymbol) {
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0];
            const base = symbol.other.base_currency;
            const acc = accountCurrency.toUpperCase();
            const product = product_type; // assuming it's globally accessible

            if (acc === base) return 1;

            const getPossibleKeys = (cur1, cur2) => [
                `${cur1}/${cur2}`,
                `${cur1}${cur2}.`,
                `${cur1}${cur2}_`,
                `${cur1}${cur2}`
            ];

            const tryGetRateFromPairs = (cur1, cur2, invert = false) => {
                const keys = getPossibleKeys(cur1, cur2);
                for (const key of keys) {
                    const item = isins[key];
                    if (item && item.A) return invert ? 1 / item.A : item.A;
                }
                return null;
            };

            // 1. Try direct and inverse rates
            let rate = tryGetRateFromPairs(acc, base, true) || tryGetRateFromPairs(base, acc, false);
            if (rate) return rate;

            // 2. Use USD as intermediary
            const toUSD = tryGetRateFromPairs(base, 'USD' + product) || tryGetRateFromPairs('USD', base + product, true);
            const fromUSD = 
                tryGetRateFromPairs(acc, 'USD' + product, true) ||
                tryGetRateFromPairs('USD', acc + product) ||
                tryGetRateFromPairs(acc, product);

            if (fromUSD && toUSD) return fromUSD * toUSD;

            // 3. Fallback using symbol directly
            const fallbackKey = acc + product;
            if (isins[fallbackKey]) {
                return Number(symbol.A || 1) / Number(isins[fallbackKey].A || 1);
            }

            return 1; // final fallback
        },
        convertCurrencyNew_old(accountCurrency, symbol, isins, side,orderSymbol){
            
            symbol.other.base_currency = symbol.other.base_currency.split('_V')[0]

            if(accountCurrency==symbol.other.base_currency){
                return 1
            }else{
                let isGet = false
                const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+""

                if(isins[firstCurrency]){
                    return 1/isins[firstCurrency].A;
                    isGet = true;
                }
                
                const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+""
                
                if(isins[firstCurrencyWithSlash]){
                    return 1/isins[firstCurrencyWithSlash].A
                    isGet = true;
                }
                
                const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()
                
                if(isins[secondCurrency]){
                    return isins[secondCurrency].A
                    isGet = true;
                }
                const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+""
                
                if(isins[secondCurrencyWithSlash]){
                    return isins[secondCurrencyWithSlash].A
                    isGet = true;
                }
                let secontoUSD = 0
                let accBasetoUSD = 0
                if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                    secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+symbol.other.base_currency+product_type]){
                    secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                    isGet = true;
                } 
                
                if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                    accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                if(!isGet){
                    this.subscribeIsisn(firstCurrency)
                    this.subscribeIsisn(firstCurrencyWithSlash)
                    this.subscribeIsisn(secondCurrency)
                    this.subscribeIsisn(secondCurrencyWithSlash)
                    this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                    this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                    this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                    this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                }
                return accBasetoUSD * secontoUSD
            }
        },
        convertCurrencyHKT(accountCurrency, symbol, isins, side,orderSymbol){

            symbol.other.base_currency = symbol.other.base_currency

            if(accountCurrency==symbol.other.base_currency){
                return 1
            }else{
                let isGet = false
                const firstCurrency = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                // console.log("firstCurrency", firstCurrency);

                if(isins[firstCurrency]){
                    return 1/isins[firstCurrency].A;
                    isGet = true
                }

                const firstCurrencyWithSlash = accountCurrency.toUpperCase()+symbol.other.base_currency+product_type

                if(isins[firstCurrencyWithSlash]){
                    return 1/isins[firstCurrencyWithSlash].A;
                    isGet = true;
                }

                const secondCurrency = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                

                if(isins[secondCurrency]){
                    return isins[secondCurrency].A;
                    isGet = true;
                }
                const secondCurrencyWithSlash = symbol.other.base_currency+accountCurrency.toUpperCase()+product_type

                if(isins[secondCurrencyWithSlash]){
                    return isins[secondCurrencyWithSlash].A;
                    isGet = true;
                }
                
                //===============================if not found
                let secontoUSD = 0
                let accBasetoUSD = 0
                if(isins[symbol.other.base_currency+"USD"+product_type]   ){
                    secontoUSD = isins[symbol.other.base_currency+"USD"+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+symbol.other.base_currency+product_type]){
                    secontoUSD = 1/isins['USD'+symbol.other.base_currency+product_type].A
                    isGet = true;
                } 
                
                if(isins[accountCurrency.toUpperCase()+'USD'+product_type]){
                    accBasetoUSD = 1/isins[accountCurrency.toUpperCase()+'USD'+product_type].A
                    isGet = true;
                } 
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                else if(isins['USD'+accountCurrency.toUpperCase()+product_type]){
                    accBasetoUSD = isins['USD'+accountCurrency.toUpperCase()+product_type].A
                    isGet = true;
                }
                if(!isGet){
                    this.subscribeIsisn(firstCurrency)
                    this.subscribeIsisn(firstCurrencyWithSlash)
                    this.subscribeIsisn(secondCurrency)
                    this.subscribeIsisn(secondCurrencyWithSlash)
                    this.subscribeIsisn(symbol.other.base_currency+"USD"+product_type)
                    this.subscribeIsisn('USD'+symbol.other.base_currency+product_type)
                    this.subscribeIsisn(accountCurrency.toUpperCase()+'USD'+product_type)
                    this.subscribeIsisn('USD'+accountCurrency.toUpperCase()+product_type)
                }
                return accBasetoUSD * secontoUSD
            }
        },
        
        getBalance() {
            clearTimeout(balanceDebounce);
            balanceDebounce = setTimeout(() => {
                this._runGetAccBalance({ globalParams: {}, localParams: { parameter: this } });
            }, 1000)
        },
    },
    async mounted(){
        // this.userList = await this.getAllUsers();
        // console.log('users ====>',this.userList)
        this.getAllUsers().then(users =>{
            // console.log("Users:", users);
            this.userList = users
        });
        const _that = this
        $(document).on("click", function(event){
			if(!$(event.target).closest('.appButton.changeUser').length){
                _that.show_dropdown = false
            }
        });
    },
    created() {
        // this.getBalance()
        if (this.$route.name != "home") {
            this._runGetOpenTradeList({ globalParams: {}, localParams: { parameter: this } });
        }
    },
};
</script>
<style>
.account-type {
    padding: 2px 5px 0px 6px;
    margin-right: 4px;
    border-radius: 2px;
}

.light-theme .account-type {
    background: var(--bordercolor);
}

.dark-theme .account-type {
    background: #1b9981;
}
</style>


// WEBPACK FOOTER //
// src/components/website/shared/header-balance.vue